export var PaymentChannelEnum;

(function (PaymentChannelEnum) {
  PaymentChannelEnum["BANCOLOMBIA_ATH"] = "BANCOLOMBIA_ATH/notifications";
  PaymentChannelEnum["BANCOLOMBIA_CORRESPONDENT"] = "BANCOLOMBIA_CORRESPONDENT/notifications";
  PaymentChannelEnum["BANCOLOMBIA_OFFICE"] = "BANCOLOMBIA_OFFICE/notifications";
  PaymentChannelEnum["PSE"] = "PSE/notifications/channel/whatsapp";
  PaymentChannelEnum["PSE_REDIRECT"] = "pse/redirect";
  PaymentChannelEnum["KUSHKI_CASH"] = "KUSHKI_CASH/notifications/channel/whatsapp";
  PaymentChannelEnum["KUSHKI_RECEIPT"] = "kushki/payment-receipts";
  PaymentChannelEnum["BOLETO_PIX"] = "invoice-notifications";
})(PaymentChannelEnum || (PaymentChannelEnum = {}));